import React from "react"
import { useParams, useHistory } from "react-router-dom"
import { useSnackbar } from "notistack"
import { useRecoilState } from "recoil"

import betaCodeExists from "../../libs/betaCodeExists"
import onboardingProgress from "../../store/onboardingProgress"

import BetaForm from "../../forms/Beta"

export default function Beta() {
  const { enqueueSnackbar } = useSnackbar()
  const [isAuthenticating, setIsAuthenticating] = React.useState(true)
  const [progress, setProgress] = useRecoilState(onboardingProgress)
  const { code } = useParams()
  const history = useHistory()

  const componentDidMount = React.useCallback(async () => {
    const fetchCode = async (id) => {
      try {
        await betaCodeExists(id)
        setProgress({
          ...progress,
          betaCode: id,
        })
        enqueueSnackbar("Welcome to the beta!", {
          variant: "success",
        })
        return history.push("/signup/start")
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar("Code has expired or does not exist", {
          variant: "error",
        })
      }
      setIsAuthenticating(false)
    }
    if (isAuthenticating && code && !progress.betaCode) {
      return fetchCode(code)
    } else {
      return setIsAuthenticating(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticating, code, progress.betaCode])

  React.useEffect(() => {
    componentDidMount()
  }, [componentDidMount])

  return !isAuthenticating && <BetaForm />
}
